<template>
    <b-table-simple small stacked borderless style="min-width:350px;">
        <b-tbody>
            <b-tr>
                <b-td v-if="customerOrder.slaveId" stacked-heading="SlaveId" class="p-0 table-stack"><copy-to-clipboard-component alertDisplayLength='1' alertShowCopiedText="true">{{customerOrder.slaveId}}</copy-to-clipboard-component></b-td>
                <b-td stacked-heading="MarketOrderId" class="p-0 table-stack"><copy-to-clipboard-component alertDisplayLength='1' alertShowCopiedText="true">{{customerOrder.marketOrderId}}</copy-to-clipboard-component></b-td>
                <b-td stacked-heading="Bestelldatum"  class="p-0 table-stack">{{orderTime}}</b-td>

                <b-td v-if="customerOrder.maybeInboundShipmentDate && customerOrder.orderState == 0" stacked-heading="Im Zulauf"  class="p-0 table-stack">{{customerOrder.maybeInboundShipmentDate}}</b-td>

                <b-td v-if="maybeMultiorderDeliveryDate" stacked-heading="Multiorder versendet" class="p-0 table-stack"><b-badge class="badge-orange">{{maybeMultiorderDeliveryDate}}</b-badge></b-td>
                <b-td v-else-if="maybeMultiorderPlaces" stacked-heading="in Warehouse" class="p-0 table-stack"><b-badge class="badge-orange">{{multiorderMoveDate}} (Platz {{ maybeMultiorderPlaces }})</b-badge></b-td>

                <b-td v-else stacked-heading="Versanddatum"  class="p-0 table-stack">{{deliveryDate}}</b-td>
                <b-td v-if="this.plannedDeliveryDate != '‒'" stacked-heading="Ge. Versanddatum"  class="p-0 table-stack">{{plannedDeliveryDate}}</b-td>
                <b-td stacked-heading="Meldedatum"    class="p-0 table-stack">{{meldedatum}}</b-td>

            </b-tr>
        </b-tbody>
    </b-table-simple>
</template>
<style scoped>
	.badge-href-red:hover {
		background-color:#f75f48 !important;
		 text-decoration: underline !important;
		cursor: pointer !important;
	}

	.badge-href-blue:hover {
		background-color:#6fb5ff !important;
		 text-decoration: underline !important;
		cursor: pointer !important;
	}

	.table-stack {
		white-space:nowrap;
	}
	.badge-purple {
		background-color:#CC33FF;
		color:white;
	}
	.badge-yellow {
		background-color:#ffe100;
		color:black;
	}
	.badge-orange {
		background-color: #fcb103;
		color: black;
	}
</style>

<script>

import moment from "moment";

export default {
	props: ["customerOrder", "IslightMode"],
	data() {
		return {
			orderTime: "",
			deliveryDate: "",
			meldedatum: null,
      multiorderMoveDate: null,
			plannedDeliveryDate: null,
			stackedTableStyle: "",
		};
	},
	computed: {
		maybeMultiorderDeliveryDate: function() {
			if(this.customerOrder
			  && this.customerOrder.customermultiorders
			  && this.customerOrder.customermultiorders.length > 0
			  && this.customerOrder.customermultiorders[0].multiorder
			  && this.customerOrder.customermultiorders[0].multiorder.deliveryDate)
			  {
				  return this.formatDate(this.customerOrder.customermultiorders[0].multiorder.deliveryDate);
			  }
			  return null;
		},
		maybeMultiorderPlaces: function() {
			if(this.customerOrder
			  && this.customerOrder.customermultiorders
			  && this.customerOrder.customermultiorders.length > 0)
			  {
				  return this.customerOrder.customermultiorders.map( cmo => (cmo.id % 10000) ).reduce(
					(accumulator, currentValue) => {
						return (accumulator == "") ? currentValue : (accumulator + ", " + currentValue)
					},
					""
				  ) 
			  }
			  return null;
		},
	},
	created()
	{ 
		this.orderTime    = this.formatDate(this.customerOrder.orderTime);
		this.deliveryDate = this.formatDate(this.customerOrder.deliveryDate);
		this.plannedDeliveryDate = this.formatDate(this.customerOrder.lastCancelationDate);
		this.meldedatum   = this.formatDate(this.customerOrder.customerOrderItemHistoryDeliveryJobLastUpdateTime);
    this.multiorderMoveDate   = this.formatDate(this.customerOrder.customerOrderItemHistoryMoveToMultiorderLastUpdateTime);

		let getTextWidth = function(text) {
			// re-use canvas object for better performance
			var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
			var context = canvas.getContext("2d");
			//context.font = font;
			var metrics = context.measureText(text);
			console.log("metrics.width: " + metrics.width);
			return metrics.width;
		}
		let txt = `MarketOrder: ${this.customerOrder.marketOrderId}`;
		//this.stackedTableStyle = `min-width: ${30 + getTextWidth(txt)}px;`;

	},
	methods: {
		openInNewTab(url) { var win = window.open(url, "_blank"); win.focus() },
		formatDate(s) {
      //console.log("Format date called with: " + s);
      const result = (s) ? moment(s).format('DD.MM.YYYY HH:mm') : '‒';
      //console.log(result)
      return result;
    },
	    getTextWidth(text, font) {
			// re-use canvas object for better performance
			var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
			var context = canvas.getContext("2d");
			//context.font = font;
			var metrics = context.measureText(text);
			console.log("metrics.width: " + metrics.width);
			return metrics.width;
		},
	}
};
</script>